import { Button, IconButton, OutlinedInput, Typography, withStyles } from '@material-ui/core';
import styled from 'styled-components';
import {MuiFormLabelFilledColorByCurrentApp, SearchWrapperBorderRadiusByCurrentApp} from '../../utils/get-app-env'
import { KeyboardDateTimePicker } from '@material-ui/pickers';

export const StyledForm = styled.form`
  width: 100%;
  height: 70%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
`;

export const Input = styled(OutlinedInput)`
  padding: 0 8px;
`;


export  const WhiteTextTypography = withStyles((theme) => ({
    root: {
      color: "#FFFFFF",
      fontSize: 22,
      marginLeft: 6
    }
  }))(Typography);

export const SearchButton = withStyles((theme) => ({
  root: {
    backgroundColor: '#F3F3F3',
    borderRadius: 6,
    color: '#7F7F7F',
    padding: '0px 16px',
    height: 45,
    '&:disabled': {
      backgroundColor: '#A8A6A6',
      color: '#FFF',
      fill: '#FFF',
      '&:disabled .search-button': {
        fill: "#FFF",
        color: "#FFF",
      },
    },
    '&:hover': {
      backgroundColor: '#A8A6A650',
      fill: "#7F7F7F",
      color: "#7F7F7F",
      '&:hover .search-button': {
        fill: "#7F7F7F",
        color: "#7F7F7F",
      },
    },
  }
}))(Button);

export const SearchButtonTypography = withStyles((theme) => ({
  root: {
    fontSize: 16,
    fontWeight: 400,
  }
}))(Typography);


export const SearchKeyboardDateTimePicker = withStyles((theme) => ({
  root: {
    padding: '10px 5px',
    backgroundColor: '#fff',
    borderRadius: 6,
    border: 'none',
    width: 306,
    height: 45,
  },
  
}))(KeyboardDateTimePicker);

export const CuttingButton = withStyles((theme) => ({
  root: {
    borderRadius: 6,
    backgroundColor: '#F3F3F3',
    color: '#7F7F7F',
    fill: '#7F7F7F',
    padding: '0px 16px',
    height: 45,
    '&:disabled': {
      backgroundColor: '#A8A6A6',
      color: '#FFF',
      fill: '#FFF',
      '&:disabled .cutting-button': {
        fill: "#FFF",
        color: "#FFF",
      },
    },
    '&:hover': {
      backgroundColor: '#A8A6A650',
      fill: "#7F7F7F",
      color: "#7F7F7F",
      '&:hover .cutting-button': {
        fill: "#7F7F7F",
        color: "#7F7F7F",
      },
      
    },
    
  },
  
}))(Button);

export const CuttingButtonTypography = withStyles((theme) => ({
  root: {
    fontSize: 16,
    fontWeight: 400,    
  }
}))(Typography);

export const CuttingTimecodeTypography = withStyles((theme) => ({
  root: {
    fontSize: 20,
    fontWeight: 400,
    color: '#7F7F7F',
  }
}))(Typography);

export const ZoomButton = withStyles((theme) => ({
  root: {
    backgroundColor: '#F3F3F3',
    borderRadius: 6,
    color: '#7F7F7F',
    fill: '#7F7F7F',
    height: 40,
    width: 40,
    '&:disabled': {
      backgroundColor: '#A8A6A6',
      color: '#FFF',
      fill: '#FFF',
    },
    '&:hover': {
      backgroundColor: '#A8A6A650',
      fill: "#7F7F7F",
      color: "#7F7F7F",
    },
    
  },
  
}))(IconButton);

export const NavigationButton = withStyles((theme) => ({
  root: {
    backgroundColor: '#F3F3F3',
    borderRadius: 6,
    color: '#7F7F7F',
    fill: '#7F7F7F',
    height: 34,
    width: 84,
    fontSize: 13,
    '&:disabled': {
      backgroundColor: '#A8A6A6',
      color: '#FFF',
      fill: '#FFF',
    },
    '&:hover': {
      backgroundColor: '#A8A6A650',
      fill: "#7F7F7F",
      color: "#7F7F7F",
    },
    
  },
  
}))(Button);

export const PlayPauseButton = withStyles((theme) => ({
  root: {
    fill: '#7F7F7F',
    transform: 'scale(1.5)',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  
  
}))(IconButton);

export const NavigationButtonTypography = withStyles((theme) => ({
  root: {
    fontSize: 13,
    fontWeight: 400,
  }
}))(Typography);

export const PlayerArea = styled.div`
  display: flex; 
  flex-direction: column; 
  justify-content: center; 
  align-items: center; 
  gap: 10px;
  width: 100%; 
  height: 100%; 

  .audio-datepicker-wrapper {
    width: 100%;
    max-width: 1280px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    button {
      cursor: pointer;
    }

    .input-icon {
      //width: 20px;
    }
  }
`;

export const CardsContainer = styled.section`
  width: 100%; 
  height: calc(100% - 200px);
  padding: 0 10px; 
  display: flex; 
  flex-direction: column; 
  gap: 10px;
  overflow-y: auto;
  padding-bottom: 85px;
`;

export const Icon = styled.img`
  :hover {
    cursor: pointer;
    fill: #fff;
  }
`;

export const PlayerControllerContainer = styled.div<{ isLoadingNewContent: boolean }>`
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 800px;
  
  .controller {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: center;
    gap: 10px;
    height: 50px;
  }

`;

export const TimeReference = styled.h1`
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  font-size: 30px;
  color: #5B5B5B;
  font-family: "Roboto", "Montserrat";
  font-weight: 500;
  padding: 1px;
`;

export const DateReference = styled.h3`
  position: absolute;
  left: 2px;
  font-size: 16px;
  color: #5B5B5B;
  font-family: "Roboto", "Montserrat";
  font-weight: 400;
  padding: 12px 0px 0px 0px;
  margin-left: 12px;
`;

export const SearchWrapper = styled.section`
  width: 100%;
  display: flex;
  padding: 20px 10px;
  
  > * {
    width: 100%;
    border-radius: ${(SearchWrapperBorderRadiusByCurrentApp())};
  }

  input {
    width: 100%;

    ::placeholder {
      color: ${(MuiFormLabelFilledColorByCurrentApp())};
    }
  }

  @media (width < 900px) {
   padding-top: 80px; 
  }
`;

export const TimelineWrapper = styled.div<{ isLoadingNewContent: boolean }>`
  pointer-events: ${props => props.isLoadingNewContent ? 'none' : 'all'};
  position: relative;
  width: 100%;
  max-width: 1280px;

  .loader-wrapper {
    display: ${props => props.isLoadingNewContent ? 'initial' : 'none'};
    z-index: 9999;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .loader {
    border: 8px solid transparent; 
    border-top: 8px solid #E94E1B;
    border-radius: 50%;
    width: 60px;
    height: 60px;
    animation: spin 1s linear infinite;
    backgroundColor: #FFF;
  }

  > div:last-child { //Timeline
    filter: ${props => props.isLoadingNewContent ? 'blur(2px)' : 'blur(0)'};
  }

  @keyframes spin {
    0% { 
      transform: rotate(0deg);
    }
    100% { 
      transform: rotate(360deg); 
    }
  }
`;

export const TimeControllerContainer = styled.div`
  display: flex; 
  position: relative; 
  width: 100%; 
  max-width: 1280px;

  > .zoom-controller {
    position: absolute;
    display: flex;
    gap: 10px; 
    right: 0;
  }
`;

export const IconsWrapper = styled.section<{ activeBorder: boolean }>`
  position: relative;
  display: flex; 
  align-items: center; 
  gap: .5rem;

  svg {
    pointer-events: none;
  }
`;

export const ContextMenuInfoTypography = withStyles((theme) => ({
  root: {
    fontSize: 17,
    fontWeight: 500,
    color: "#7F7F7F",
    fill: "#7F7F7F",
    height: 40,
    verticalAlign: 'middle',
    display: 'inline-flex'
  }
}))(Typography);

export const ContextMenuTypeTypography = withStyles((theme) => ({
  root: {
    fontSize: 14,
    fontWeight: 400,
    color: "#E94E1B",
  }
}))(Typography);

export const ContextMenuDescTypography = withStyles((theme) => ({
  root: {
    fontSize: 14,
    fontWeight: 400,
    color: "#7F7F7F",
  }
}))(Typography);

export const ContextMenuDownloadButton = withStyles((theme) => ({
  root: {
    fontSize: 16,
    fontWeight: 400,
    color: "#FFFFFF",
    backgroundColor: "#E94E1B",
    borderRadius: 6,
    width: 215,
    margin: "10px 32px 25px 32px",
    '&:hover': {
      backgroundColor: '#E94E1B99',
    },
  }
}))(Button);


